import { queryClient } from 'App';
import useAppMutation from 'hooks/useAppMutation';
import useNotify from 'hooks/useNotify';
import API from 'services/API';
import { useTranslation } from 'react-i18next';
import { getErrorMessage } from 'utils/axiosExceptionUtils';
import { getIntegrationAgencySettingsQueryKey } from 'hooks/useFetchIntegrationAgencySettings';
import { IntegrationEnum } from 'models/InternalIntegrationSetting';

const usePinCodeSizeMutation = () => {
  const { notifyError } = useNotify();
  const { t } = useTranslation();

  return useAppMutation({
    mutationFn: async ({
      pinCodeSize,
    }: {
      enumId: IntegrationEnum;
      pinCodeSize: number;
    }) => {
      const response = await API.post(
        '/api/internal/integrations/remotelock/settings/pincode-length',
        {
          pinCodeSize,
        },
      );

      return response.data;
    },
    onSettled: (_, __, { enumId }) => {
      queryClient.invalidateQueries({
        queryKey: getIntegrationAgencySettingsQueryKey({ enumId }),
      });
    },
    onError: (error: any) => {
      notifyError(
        getErrorMessage({
          apiErrorCode: error.response?.data?.apiErrorCode,
          apiErrorMessage: error.response?.data?.apiErrorMessage,
          baseKey: 'pageIntegrations.apiErrorCodes.',
          t,
        }),
      );
    },
  });
};

export default usePinCodeSizeMutation;
